import { render, staticRenderFns } from "./OrderConsult.vue?vue&type=template&id=d0633912&scoped=true"
import script from "./OrderConsult.vue?vue&type=script&lang=js"
export * from "./OrderConsult.vue?vue&type=script&lang=js"
import style0 from "./OrderConsult.vue?vue&type=style&index=0&id=d0633912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0633912",
  null
  
)

export default component.exports